import Vue from 'vue';
import Auth from '@js/plugins/auth';

Vue.component('report-fuel-index', () =>
    import(/* webpackChunkName: 'report-fuel-index' */ './report-fuel-index.vue'),
);

Vue.component('report-pttm', () =>
    import(/* webpackChunkName: 'report-pttm' */ './report-pttm.vue'),
);

if (Auth.metas().environment === 'bhp') {
    Vue.component('report-movement-index', () =>
        import(/* webpackChunkName: 'report-movement-index' */ './bhp/report-movement-index.vue'),
    );
} else {
    Vue.component('report-movement-index', () =>
        import(/* webpackChunkName: 'report-movement-index' */ './report-movement-index.vue'),
    );
}



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/fuel/index.js